<!-- [팝업] 우선순위 설정 -->
<template>
  <b-modal
    v-model="showMainTopFixManage"
    cancel-variant="outline-secondary"
    centered
    ok-title="저장"
    cancel-title="취소"
    size="lg"
    title="우선순위 설정"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row class="mt-1">
      <b-list-group>
        <draggable
          v-model="fixedItems"
          class="list-group list-group-flush cursor-move"
          tag="ul"
          handle=".draggable-task-handle"
        >
          <transition-group
            type="transition"
            name="flip-list"
          >
            <b-list-group-item
              v-for="(fixItem, index) in fixedItems"
              :key="`${fixItem.contentType}-${fixItem.contentId}`"
              tag="li"
            >
              <span class="d-flex">
                <!-- <b-col>{{ fixItem.mainTopFixLevel }}</b-col> --><b-col>{{ index + 1 }}</b-col><!-- 이동 시 저장 전에도 실시간으로 숫자 갱신 -->
                <!-- <b-col>{{ fixItem.contentType }}</b-col> -->
                <b-col>{{ fixItem.contentTypeName }}</b-col>
                <b-col>{{ fixItem.contentId }}</b-col>
                <b-col>{{ fixItem.clientName }}</b-col>
                <b-col>{{ fixItem.contentTitle }}</b-col>
                <!-- <b-col>{{ fixItem.mainStartDate }}</b-col> -->
                <!-- <b-col>{{ fixItem.mainEndDate }}</b-col> -->
                <b-col>{{ fixItem.period }}</b-col>
                <!-- <b-col>{{ fixItem.postStatus }}</b-col> -->
                <b-col>{{ fixItem.postStatusName }}</b-col>
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="draggable-task-handle d-inline"
                />
              </span>
            </b-list-group-item>
          </transition-group>
        </draggable>
      </b-list-group>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import dayjs from 'dayjs'
import { ref, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter } from '@core/utils/filter'
import draggable from 'vuedraggable'
import { BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
  components: {
    draggable,
    BListGroup,
    BListGroupItem,
  },

  props: {
    showMainTopFixManage: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    watch(() => props.showMainTopFixManage, newVal => {
      if (newVal) {
        // showMainTopFixManage 가 true로 변경될 때 fetchMainTopFixs 호출
        fetchMainTopFixs()
      }
    })

    const toast = useToast()

    const fixedItems = ref(null)
    let ogFixedItems = null

    const fetchMainTopFixs = () => {
      axios.get('/fa/main-top-fix/list')
        .then(rs => {
          fixedItems.value = rs.data

          ogFixedItems = [...fixedItems.value]
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: errorFormatter(error, '데이터 조회에 실패하였습니다.'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const close = () => {
      emit('close', null)
    }

    const submit = () => {
      const elements = fixedItems.value

      axios.post('/fa/main-top-fix/change-element-order', elements)
        .then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: '데이터 저장 완료',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })

          emit('close', fixedItems.value)
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: '데이터 저장 과정에서 오류가 발생하였습니다.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    return {
      close,
      submit,
      fetchMainTopFixs,

      fixedItems,
      ogFixedItems,
    }
  },
}
</script>
